/**
 * Test IDs for QA automation.
 */
export const testIds = {
  paymentRuleFormPaymentMethod: "payment-rule-form-payment-method",
  paymentRuleFormMethodOption: "payment-rule-form-method-option",
  paymentRuleFormAmount: "payment-rule-form-amount",
} as const;
